import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "حاسبة مربع العدد - حساب مربع الأعداد بدقة وسرعة";
const DESCRIPTION =
  "استخدم أداة حساب مربع الأعداد للحصول على نتائج دقيقة وسريعة في حساب مربع أي عدد، سواء كان عددًا صحيحًا أو عددًا عشريًا. هذه الحاسبة مثالية للطلاب، المعلمين، والمهندسين، وتساعد في حل المسائل الرياضية، حساب المساحات والأحجام في الهندسة، وتبسيط المعادلات الجبرية. تتميز بواجهة مستخدم بديهية وسهلة الاستخدام، وتدعم مجموعة متنوعة من الأرقام.";
const KEYWORDS =
  "حساب مربع العدد، حاسبة مربع الأعداد، أداة تعليمية رياضية، حل المسائل الرياضية، حساب المساحات، حساب الأحجام، أداة رياضية دقيقة، حاسبة الأعداد العشرية";
const OG_URL = "https://do-calculate.com/calculator/ar/squared-calculator";
const SquaredCalculator = () => {
  const [number, setNumber] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (!number) {
        throw new Error("الرجاء إدخال رقم.");
      }
      const num = parseFloat(number);
      if (isNaN(num)) throw new Error("الرجاء إدخال رقم صحيح.");
      const res = number * number;
      setResult(res);
      setError("");
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  استخدم هذه الأداة المتقدمة لحساب مربع الأعداد بدقة وسرعة. سواء
                  كنت تحتاج إلى حساب مربع عدد صحيح أو عدد عشري، توفر لك الحاسبة
                  نتائج دقيقة بشكل فوري. تعد هذه الأداة مثالية للطلاب، المعلمين،
                  والمهندسين، حيث تسهم في حل المسائل الرياضية المعقدة، حساب
                  المساحات والأحجام في الهندسة، وتبسيط المعادلات الجبرية. بفضل
                  واجهتها البديهية وسهولة استخدامها، تدعم الأداة مجموعة متنوعة
                  من الأرقام، مما يجعلها خياراً ممتازاً لتلبية احتياجاتك
                  التعليمية والمهنية في الرياضيات.
                </p>
              </div>
            </div>
                <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">أدخل الرقم</label>
                      </b>
                      <input
                        type="text"
                        placeholder="مثال: 12"
                        value={number}
                        onChange={(e) => setNumber(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  <div>
                    { error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      result !== null && (
                        <div className="p-3 mb-2 bg-success text-white">
                          <p className="text-white">النتيجة: {result}</p>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>التربيع</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        تربيع الرقم هو عملية حسابية تتضمن ضرب الرقم في نفسه
                        للحصول على مربع ذلك الرقم. مربع أي عدد هو حاصل ضرب العدد
                        في نفسه. على سبيل المثال، مربع العدد 5 هو 5 مضروب في 5،
                        والنتيجة هي 25. وبشكل عام، مربع أي رقم يُرمز إليه برفع
                        الرقم إلى القوة الثانية، مثل 5²، ويعني ذلك 5 مضروب في 5.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
    </div>
  );
};
export default SquaredCalculator;
